export default __webpack_public_path__ + "static/countdown_siri_1-fcb87b9f05552c232fae957e7133b301.png";